export default "__VITE_ASSET__BlmE$dwi__"